module.exports = __webpack_public_path__ + "static/media/music-and-multimedia.8daa5bc5.png";